import { services } from './data';
import Service from './Service';
import { useTranslation } from "react-i18next";


const ServicesComponentBanner = () => {
  const { t } = useTranslation();

  return (
    <section className='section bg-grey' id='services'>
      <h2 className="timeline-title-ticket">{t("services.banner_title")}</h2>

      <div className='services-center section-center'>
        {services.map((service) => (
          <Service {...service} key={service.id} />
        ))}
      </div>
    </section>
  );
}
export default ServicesComponentBanner;
